export default __webpack_public_path__ + "static/media/footer_bg.774a5333.png";